import { useMemo, useState } from 'react';
import { defaultDataFilters, filterRows } from '../utils/dataSearch';

/**
 * Search state for a master data table. `fields` must be stable (define them outside the component).
 * Returns the filtered rows and the props for <DataSearchFilters>; `onChange` runs on every change,
 * e.g. to go back to page 1.
 */
export default function useDataSearch(rows, fields, { onChange } = {}) {
  // Starts with (and resets to) the fields' default values, e.g. Status: Active
  const [filters, setFilters] = useState(() => defaultDataFilters(fields));
  const filtered = useMemo(() => filterRows(rows ?? [], fields, filters), [rows, fields, filters]);

  const panelProps = {
    fields,
    rows: rows ?? [],
    filters,
    onChange: (patch) => {
      setFilters((f) => ({ ...f, ...patch }));
      onChange?.();
    },
    onReset: () => {
      setFilters(defaultDataFilters(fields));
      onChange?.();
    },
  };

  return { filtered, filters, panelProps };
}
